// extracted by mini-css-extract-plugin
export var drawerContent = "_3b-0";
export var valueBlock = "_3b-1";
export var valueBlockFrom = "_3b-2 _3b-1";
export var valueBlockTo = "_3b-3 _3b-1";